module.exports = __webpack_public_path__ + "static/assets/055da71fc85b343f8896c0bd80258707.svg";